import React from 'react'
import useI18n from '../../../i18n/useI18n'
import { formatDateTime, getStatusColor, getStatusLabelKey } from '../utils'

const LatestApplicationsCard = ({ items = [], loading }) => {
  const { t } = useI18n()

  return (
    <div className="card dashboard-card">
      <div className="header">
        <h2><strong>{t('DASHBOARD_CARD_LATEST_APPLICATIONS_TITLE')}</strong></h2>
        <small>{t('DASHBOARD_CARD_LATEST_APPLICATIONS_SUBTITLE')}</small>
      </div>
      <div className="body">
        {loading && !items.length && <div className="skeleton-table"></div>}
        {!loading && !items.length && (
          <div className="empty-state">{t('DASHBOARD_CARD_LATEST_APPLICATIONS_EMPTY')}</div>
        )}
        {items.length > 0 && (
          <div className="table-responsive dashboard-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  {/* <th>{t('DASHBOARD_TABLE_APPLICATION')}</th> */}
                  <th>{t('DASHBOARD_TABLE_STATUS')}</th>
                  <th>{t('DASHBOARD_TABLE_PROGRAM')}</th>
                  <th>{t('DASHBOARD_TABLE_UNIVERSITY')}</th>
                  <th>{t('DASHBOARD_TABLE_DATE')}</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    {/* <td>{item.id}</td> */}
                    <td>
                      <span
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(item.status), color: '#fff' }}
                      >
                        {t(getStatusLabelKey(item.status))}
                      </span>
                    </td>
                    <td>{item.program?.name || t('COMMON_NOT_AVAILABLE')}</td>
                    <td>{item.university?.name || t('COMMON_NOT_AVAILABLE')}</td>
                    <td>{formatDateTime(item.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default LatestApplicationsCard

